/* eslint-disable max-lines */
import {Helmet} from "react-helmet";
import NavigationControls from "./NavigationControls";
import PropTypes from "prop-types";
import React from "react";
import StyleSurveyAPI from "../modules/StyleSurveyAPI";
import {checkProgress} from "../modules/checkProgress";
import {getPageTitle} from "../modules/StyleSurveyHelper";

export default class StyleSurveyFinish extends React.PureComponent {

  static propTypes = {
    "customer": PropTypes.object,
    "header": PropTypes.element.isRequired,
    "location": PropTypes.object.isRequired,
    "nextRoute": PropTypes.string,
    "onAnswer": PropTypes.func.isRequired,
    "prevRoute": PropTypes.string,
    "setBirthday": PropTypes.func.isRequired,
    "skip": PropTypes.object,
    "surveyFields": PropTypes.object.isRequired
  };

  static defaultProps = {
    "customer": {
      "birthday": null,
      "entry_time": null,
      "id": null,
      "source": null
    },
    "nextRoute": null,
    "prevRoute": null,
    "skip": null
  };

  constructor (props) {
    super(props);

    const {
      "customer": {birthday, "source": customerSource, "reason": customerReason},
      "surveyFields": {
        buyerQuestion1, buyerQuestion1Shown, buyerQuestion2, buyerQuestion2Shown,
        buyerQuestion3, buyerQuestion3Shown, buyerQuestion4, buyerQuestion4Shown, openQuestion1
      }
    } = this.props;
    const birthdayArray = birthday
      ? birthday.toString().split("-")
      : [0, 0, 0]; // eslint-disable-line array-element-newline

    this.state = {
      "birthyear": parseInt(birthdayArray.shift(), 10),
      "birthmonth": parseInt(birthdayArray.shift(), 10), // eslint-disable-line sort-keys
      "birthday": parseInt(birthdayArray.shift(), 10), // eslint-disable-line sort-keys
      buyerQuestion1,
      buyerQuestion1Shown,
      buyerQuestion2,
      buyerQuestion2Shown,
      buyerQuestion3,
      buyerQuestion3Shown,
      buyerQuestion4,
      buyerQuestion4Shown,
      customerReason,
      customerSource,
      "openQuestion1": openQuestion1 || "",
      "showReasonQuestion": this.isBuyerQuestionsHidden,
      "showReportedSource": false,
      "showSourceQuestion": this.isBuyerQuestionsHidden
    };

    this.darkAges = (new Date()).getFullYear() - 120;
    this.monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ];
    this.buyerAnswers = [
      "Yes",
      "No",
      "Not Sure"
    ];
    this.renterAnswers = [
      "Renting",
      "Buying",
      "Not Sure"
    ];
    this.buyerQuestion4Answers = [
      "To have access to new jewelry all the time",
      "To discover new styles and brands",
      "To try new jewelry without the commitment to buy",
      "To receive jewelry styled just for me",
      "To buy new jewelry",
      "To receive jewelry delivered to my doorstep"
    ];
    this.reasons = [
      "So I always have new jewelry to wear",
      "To discover jewelry styles and trends",
      "To find jewelry for an upcoming event",
      "For personalized recommendations on jewelry I would like",
      "To buy new jewelry to add to my collection",
      "To get discounts on designer jewelry"
    ];
    this.sources = [
      "Blog",
      "Event",
      "E-mail",
      "Employee",
      "Facebook",
      "Google",
      "In-App Reward",
      "In-store",
      "Instagram",
      "Invited by Friend",
      "Magazine",
      "Mobile Game",
      "News",
      "Online Article",
      "Online Banner Ad",
      "Pinterest",
      "Podcast",
      "Snapchat",
      "Spotify",
      "TikTok",
      "TV",
      "Twitter",
      "Word of Mouth",
      "Youtube",
      "Other"
    ];
  }

  componentDidMount = () => {
    checkProgress();
  }

  isBuyerQuestionsHidden = () => {
    const {buyerQuestion1Shown, buyerQuestion2Shown, buyerQuestion3Shown, buyerQuestion4Shown} = this.state;

    return !buyerQuestion1Shown && !buyerQuestion2Shown && !buyerQuestion3Shown && !buyerQuestion4Shown;
  }

  handleOpenQuestionChange = (event) => {
    const openQuestion1 = event.target.value;

    this.setState({openQuestion1}, () => {
      const {onAnswer} = this.props;
      onAnswer({openQuestion1});
    });
  };

  handleBirthdayChange = (event) => {
    const stateObj = {};
    const {"target": {value}} = event;

    stateObj[`birth${event.target.getAttribute("id")}`] = value;
    this.setState(stateObj, () => {
      const {"customer": {id}, setBirthday} = this.props;
      const {birthday, birthmonth, birthyear} = this.state;
      const birthdate = new Date(birthyear, birthmonth - 1, birthday);

      if (id && [
        "Month",
        "Day",
        "Year"
      ].indexOf(value) === -1) {
        StyleSurveyAPI.updateCustomer(id, {"birthday": birthdate});
      }
      setBirthday(birthdate);
    });
  };

  /* eslint-disable react/destructuring-assignment */
  handleBuyerClick = (event) => {
    const updateAnswer = questionForUpdate => this.setState(questionForUpdate, () => {
      const {onAnswer} = this.props;
      onAnswer(questionForUpdate);
    });

    if (this.state.buyerQuestion1Shown) {
      const buyerQuestion1 = event.target.getAttribute("value");
      updateAnswer({buyerQuestion1});
    } else if (this.state.buyerQuestion2Shown) {
      const buyerQuestion2 = event.target.getAttribute("value");
      updateAnswer({buyerQuestion2});
    } else if (this.state.buyerQuestion3Shown) {
      const buyerQuestion3 = event.target.getAttribute("value");
      updateAnswer({buyerQuestion3});
    } else if (this.state.buyerQuestion4Shown) {
      const buyerQuestion4 = event.target.getAttribute("value");
      updateAnswer({buyerQuestion4});
    }
  };
  /* eslint-enable react/destructuring-assignment */

  handleSourceChange = (event) => {
    const customerSource = event.target.value;
    if (customerSource === "Other") {
      this.setState({"showReportedSource": true});
      return;
    }

    this.setState({customerSource}, () => {
      const {onAnswer} = this.props;
      onAnswer({"source": customerSource});
    });
  };

  handleReasonChange = (event) => {
    const customerReason = event.target.value;

    this.setState({customerReason}, () => {
      const {onAnswer} = this.props;
      onAnswer({"reason": customerReason});
    });
  };

  setAnswerClassName = (buyerQuestion, answerOptions, answer) => {
    let answerClass = "btn inline-block";
    buyerQuestion === answer
      ? answerClass = answerClass.concat(" btn-primary")
      : answerClass = answerClass.concat(" btn-secondary");
    answerOptions === this.buyerQuestion4Answers
      ? answerClass = answerClass.concat(" btn-small buyer-question-4")
      : answerClass = answerClass.concat(" third-wide");
    return answerClass;
  };

  renderBuyerQuestion = (buyerQuestion, question, answerOptions) =>
    (
      <React.Fragment>
        <p className="pt16 pb16 display-linebreak">
          {question}
        </p>
        <div className="StyleSurveyAnswers mb16 full-wide">
          {answerOptions.map(answer =>
            <a
              className={this.setAnswerClassName(buyerQuestion, answerOptions, answer)}
              key={`buyerAnswer ${answer}`}
              onClick={this.handleBuyerClick}
              value={answer}
            >
              {answer}
            </a>)
          }
        </div>
      </React.Fragment>
    );

  renderSourceQuestion = customerSource =>
    (
      <React.Fragment>
        <p className="pt16 pb16">
          How did you hear about us?
        </p>
        <select
          aria-label="How did you hear about us?"
          id="source"
          name="source"
          onChange={this.handleSourceChange}
          value={customerSource || ""}
        >
          <option>
            Select an option below
          </option>
          {this.sources.map(source =>
            <option
              key={`reportedSource ${source}`}
              value={source}
            >
              {source}
            </option>)}
        </select>
      </React.Fragment>
    )

  renderReasonQuestion = customerReason =>
    (
      <React.Fragment>
        <p className="pt16 pb16">
          Why are you joining Rocksbox?
        </p>
        <select
          aria-label="Why are you joining Rocksbox?"
          id="reason"
          name="reason"
          onChange={this.handleReasonChange}
          value={customerReason || ""}
        >
          <option>
            Select an option below
          </option>
          {this.reasons.map(reason =>
            <option
              key={`reportedReason ${reason}`}
              value={reason}
            >
              {reason}
            </option>)}
        </select>
      </React.Fragment>
    )

  renderSourceQuestionReportedSource = customerSource =>
    (
      <React.Fragment>
        <textarea
          onChange={this.handleSourceChange}
          placeholder="Mind telling us how you heard about Rocksbox?"
          value={customerSource || ""}
        />
      </React.Fragment>
    )

  render () {
    const {customer, header, location, nextRoute, onAnswer, prevRoute, skip} = this.props;
    const {pathname} = location;
    const {
      birthday,
      birthmonth,
      birthyear,
      buyerQuestion1,
      buyerQuestion1Shown,
      buyerQuestion2,
      buyerQuestion2Shown,
      buyerQuestion3,
      buyerQuestion3Shown,
      buyerQuestion4,
      buyerQuestion4Shown,
      customerReason,
      customerSource,
      openQuestion1,
      showReasonQuestion,
      showReportedSource,
      showSourceQuestion
    } = this.state;
    const {id} = customer;

    return (
      <React.Fragment>
        <Helmet>
          <title>
            {getPageTitle(pathname)}
          </title>
        </Helmet>

        <div className="StyleSurveyFinish">
          {header}
          <div
            className="StyleSurveyAnswers mb16"
          >
            <textarea
              aria-label="Anything else you'd like to share with your stylist?"
              onChange={this.handleOpenQuestionChange}
              placeholder="Colors or designers you dislike, metal allergies, style preferences, upcoming events, etc."
              value={openQuestion1 || ""}
            />
            <p className="pt16 pb0">
              When is your birthday? (optional)
            </p>
            <select
              aria-label="birth month"
              id="month"
              name="birthday"
              onChange={this.handleBirthdayChange}
              value={birthmonth}
            >
              <option>
                Month
              </option>
              {this.monthNames.map((monthName, index) =>
                <option
                  key={`birthmonth ${monthName}`}
                  value={index + 1}
                >
                  {monthName}
                </option>)}
            </select>
            <select
              aria-label="birth day"
              id="day"
              name="birthday"
              onChange={this.handleBirthdayChange}
              value={birthday}
            >
              <option>
                Day
              </option>
              {Array(31).fill().map((_item, index) =>
                <option
                  key={`birthday ${index + 1}`} // eslint-disable-line react/no-array-index-key
                  value={index + 1}
                >
                  {index + 1}
                </option>)}
            </select>
            <select
              aria-label="birth year"
              id="year"
              name="birthday"
              onChange={this.handleBirthdayChange}
              value={birthyear}
            >
              <option>
                Year
              </option>
              {Array(120).fill().map((_item, index) =>
                <option
                  key={`birthyear ${this.darkAges + index + 1}`} // eslint-disable-line react/no-array-index-key
                  value={this.darkAges + index + 1}
                >
                  {this.darkAges + index + 1}
                </option>)}
            </select>
            {!id && buyerQuestion1Shown &&
              this.renderBuyerQuestion(
                buyerQuestion1,
                "Would you buy the jewelry you rent if you love it? \n (p.s. you get $21 credit per month)",
                this.buyerAnswers
              )
            }
            {!id && buyerQuestion2Shown &&
              this.renderBuyerQuestion(
                buyerQuestion2,
                "Are you interested in buying pieces you love from your set?",
                this.buyerAnswers
              )
            }
            {!id && buyerQuestion3Shown &&
              this.renderBuyerQuestion(
                buyerQuestion3,
                "Rocksbox is a rental service with the option to buy. Are you more interested in renting or buying?",
                this.renterAnswers
              )
            }
            {!id && buyerQuestion4Shown &&
              this.renderBuyerQuestion(
                buyerQuestion4,
                "Which statement best describes why you are joining Rocksbox?",
                this.buyerQuestion4Answers
              )
            }
            {!id && showReasonQuestion &&
              this.renderReasonQuestion(customerReason)
            }
            {!id && !showReportedSource && showSourceQuestion &&
              this.renderSourceQuestion(customerSource)
            }
            {!id && showReportedSource &&
              this.renderSourceQuestionReportedSource(customerSource)
            }
          </div>
          <NavigationControls
            customer={customer}
            final
            nextRoute={nextRoute}
            onAnswer={onAnswer}
            prevRoute={prevRoute}
            skip={skip}
          />
        </div>
      </React.Fragment>
    );
  }
}
